import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { decodeSearchParams } from '../utils/decodeSearchParams';

// Substitui `useSearchParams` do react-router onde os valores viram dado persistido — ver
// `decodeSearchParams`.
export const useDecodedSearchParams = (): URLSearchParams => {
  const { search } = useLocation();

  return useMemo(() => decodeSearchParams(search), [search]);
};
